import { render, staticRenderFns } from "./inventoryEditPage.vue?vue&type=template&id=28e757dc&"
import script from "./inventoryEditPage.vue?vue&type=script&lang=ts&"
export * from "./inventoryEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports